// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"181":"cb592921","858":"d2b1fac1"}[chunkId] + ".css";
};